import src from "IMAGE";
export default { src, width: 372, height: 93, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AIuLi3dubm5eRkZGOUFBQTU0NDQrLi4uJTExMSkxMTEoAJeXl4V0dHRkY2NjTm1tbVFvb29SbW1tUmpqalBzc3NUuCwWPdr3QwEAAAAASUVORK5CYII="};
